"use client";

import { useTranslations } from "next-intl";

import { Title } from "@/shared/components/title";
import { tp } from "@/shared/utils/typograf";
import { Subtitle } from "@/shared/components/subtitle";
import { Button } from "@/shared/components/button";
import { TELEGRAM_BOT_URL } from "@/shared/constants/telegram";
import { APP_BASE_URL } from "@/shared/constants/appBaseUrl";

import TelegramIcon from "@/shared/icons/telegram.svg";
import BrowserIcon from "@/shared/icons/browser.svg";
import Image from "next/image";

export const OneService = () => {
  const t = useTranslations("oneService");
  const tCta = useTranslations("common.cta");

  return (
    <div className="one-service-container">
      <div className="relative z-30 section-container">
        {/* pb на мобильном оставляет место превью, которое прижато к низу секции. */}
        <div className="pt-14 pb-75 space-y-8 lg:py-30 lg:space-y-10.5">
          <div className="space-y-4">
            <Title className="max-w-96">{tp.execute(t("title"))}</Title>
            <Subtitle>{tp.execute(t("subtitle"))}</Subtitle>
          </div>
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
            <Button
              className="w-full lg:w-auto"
              render={
                <a
                  href={TELEGRAM_BOT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              }
            >
              <TelegramIcon className="size-5" />
              <span>{tp.execute(tCta("openInTelegram"))}</span>
            </Button>
            <Button
              variant="secondary"
              className="w-full lg:w-auto"
              render={
                <a
                  href={APP_BASE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              }
            >
              <BrowserIcon className="size-5" />
              <span>{tp.execute(tCta("openInBrowser"))}</span>
            </Button>
          </div>
        </div>
      </div>
      <div className="one-service-background">
        <Image
          src="/images/easy_to_use-background.png"
          width={1453}
          height={969}
          alt="Easy To Use Background"
          className="one-service-image"
          quality={100}
        />
      </div>
      <div className="one-service-preview">
        <Image
          src="/images/footer-preview.png"
          width={648}
          height={527}
          alt="Easy To Use Background"
          className="one-service-preview-image"
          quality={100}
        />
      </div>
    </div>
  );
};
